export const getLightRatingColor = (lightRatingValue: number) => {
  if (lightRatingValue >= 0 && lightRatingValue < 2) {
    return '#D72E09';
  } else if (lightRatingValue >= 2 && lightRatingValue < 6) {
    return '#F27B0B';
  } else if (lightRatingValue >= 6 && lightRatingValue < 8) {
    return '#F3E704';
  } else if (lightRatingValue >= 8 && lightRatingValue < 9) {
    return '#DEEB02';
  } else if (lightRatingValue >= 9 && lightRatingValue < 10) {
    return '#A6F80A';
  } else if (lightRatingValue === 10) {
    return '#2CE722';
  }
  return '#2CE722';
};
